import { render } from "./actionsComp.vue?vue&type=template&id=66c89065&scoped=true"
import script from "./actionsComp.vue?vue&type=script&lang=js"
export * from "./actionsComp.vue?vue&type=script&lang=js"

import "./actionsComp.vue?vue&type=style&index=0&id=66c89065&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c89065"]])

export default __exports__